import { FC, ReactNode, useEffect, useState } from 'react';
import { MODAL_TEST_IDS } from '@connect-x-app/web-test-ids';
import classnames from 'classnames';

import { ModalOpener } from './ModalOpener';

import './modalWrapper.scss';

export const ModalWrapper: FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [children, setChildren] = useState<ReactNode>(null);

  useEffect(() => {
    ModalOpener.initialize((render: () => ReactNode) => setChildren(render()));
  }, []);

  useEffect(() => {
    setIsVisible(!!children);
  }, [children, setIsVisible]);

  return (
    <div className={classnames('modal-wrapper', { 'is-visible': isVisible })} data-test={MODAL_TEST_IDS.wrapper}>
      <div className="modal-wrapper-content">{children}</div>
    </div>
  );
};
